
export default {
    namespaced: true,
    state: {
        /**通知弹窗控制 */
        noticeVisiable:false,
        /**消息内容 */
        msgContent:{},
        /**未读消息数量 */
        messageCount:0
    },
    mutations: {
        changeNoticeVisiable(state,value){
            state.noticeVisiable=value;
        },
        changeMsgContent(state,value){
            state.msgContent=value;
        },
        changeMsgNum(state,value){
            state.messageCount = value;
        },
    },
};